import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Same Firebase project as the main Cannalytix app and partner-dashboard.
// All three dashboards share one Firebase Auth user pool; the /users/{uid}.role
// and the advertisers/partners collection memberships determine which dashboard
// a given user can access.
const firebaseConfig = {
  apiKey: 'AIzaSyDHCZV6W7RmDfgYxP1PN63pf7xtD4qkG94',
  authDomain: 'link-tracker-26f00.firebaseapp.com',
  projectId: 'link-tracker-26f00',
  storageBucket: 'link-tracker-26f00.firebasestorage.app',
  messagingSenderId: '107013313043',
  appId: '1:107013313043:web:03bd59885273304a0025e6',
  measurementId: 'G-53T7978V6L',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export default app;
